// extracted by mini-css-extract-plugin
export default {"table":"styles_table__lYKgp","detailTable":"styles_detailTable__vMGEy"};